// extracted by mini-css-extract-plugin
export var container = "_b8-0";
export var content = "_b8-3";
export var customerTitle = "_b8-4";
export var empty = "_b8-5";
export var gray = "_b8-6";
export var header = "_b8-7";
export var info = "_b8-8";
export var loading = "_b8-2";
export var loadingCard = "_b8-9";
export var oneLine = "_b8-a";
export var personName = "_b8-e";
export var pillContainer = "_b8-b";
export var selected = "_b8-1";
export var text = "_b8-c";
export var twoLines = "_b8-d";
export var unread = "_b8-f";
export var unreadIndicator = "_b8-g";